if (!customElements.get("product-form")) {
  const INTEREST_CATEGORY_TAGS = [
    "kedi-mama-beslenme",
    "kedi-kumlari",
    "kedi-mama-ve-su-kaplari",
    "kedi-bakim-urunleri",
    "kedi-oyuncaklari",
    "kedi-saglik-urunleri",
    "kedi-tasmalari",
    "kedi-aksesuarlari",
    "kedi-egitim-urunleri",
    "kedi-kafesleri",
    "kedi-kapilari",
    "kedi-tasima-cantalari-ve-seyahat-urunleri",
    "kedi-tuvaleti-ve-urunleri",
    "kedi-tirmalamalari",
    "kedi-yataklari",
    "kedi-urunleri",
    "kisisellestirilmis-kedi-urunleri",
    "kopek-mama---beslenme",
    "kopek-aksesuarlari",
    "kopek-bakim-urunleri",
    "kopek-egitim-urunleri",
    "kopek-kafesleri",
    "kopek-kapilari",
    "kopek-kulubeleri",
    "kopek-mama-ve-su-kaplari",
    "kopek-oyuncaklari",
    "kopek-saglik-urunleri",
    "kopek-seyahat-urunleri",
    "kopek-tasmalari",
    "kopek-tasima-cantalari",
    "kopek-yataklari",
    "kisisellestirilmis-kopek-urunleri",
    "yavru-kedi",
    "yavru-kopek",
    "kopek-temizlik---tuvalet-urunleri",
    "kedi-haftalik-i̇ndirimler",
    "kopek-haftalik-i̇ndirimler",
    "8-in-1",
    "acana",
    "aclium",
    "advance",
    "animal-world",
    "animonda",
    "beeztees",
    "biokats",
    "brit-fresh",
    "brit-veterinary",
    "chompo",
    "delibon",
    "doggie",
    "econature",
    "ever-clean",
    "felicia",
    "furminator",
    "gimcat",
    "gimdog",
    "gourmet-gold",
    "gourmet-perle",
    "trixie",
    "hills-science-plan",
    "imac",
    "jadawa",
    "juno",
    "kong",
    "la-vital",
    "lepus",
    "lindo-dogs",
    "lindocat",
    "m-pets",
    "menforsan",
    "mera",
    "miamor",
    "midos",
    "moderna",
    "moow",
    "mps",
    "n-d-prime",
    "n-d-ocean",
    "n-d-pumpkin",
    "natures-variety",
    "onevet",
    "orijen",
    "pawgether",
    "petzzcats",
    "petzzdogs",
    "pro-choice",
    "pro-nutrition",
    "pro-performance",
    "pro-plan",
    "proclean",
    "pro-line",
    "dog-chow",
    "purina-one",
    "ranova",
    "reflex",
    "reflex-plus",
    "rico",
    "royal-canin",
    "schesir",
    "signature",
    "stefanplast",
    "tofucat",
    "vetsmell",
    "voskes",
    "wanpy",
    "zampa",
    "kopek-kiyafetleri",
    "kopek-ayakkabilari",
    "kopek-tirnak-ve-pati-bakimi",
    "kopek-deri-ve-tuy-bakimi",
    "kopek-sirt-cantalari",
    "kopek-hazneli-mama-ve-su-kaplari",
    "kopek-zeka-oyuncaklari",
    "odul-hazneli-kopek-oyuncaklari",
    "dis-ipi-kopek-oyuncaklari",
    "kopek-cigneme-oyuncaklari",
  ];

  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector("form");
        //this.form.querySelector('[name=id]').disabled = false;
        this.variantIdInput.disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector("span");
        if (document.querySelector("cart-drawer")) {
          if (this.submitButton) {
            this.submitButton.setAttribute("aria-haspopup", "dialog");
          }
        }

        this.hideErrors = this.dataset.hideErrors === "true";

        this.initializeAutoshipSelector();

        // Patisanat image upload handling
        this.isPatisanat = this.dataset.patisanat === "true";
        if (this.isPatisanat) {
          this.setupPatisanatImageUpload();
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        // Check if this is a "Notify Me" button
        if (this.submitButton.classList.contains("is-notify-button")) {
          this.handleNotifyMe();
          return;
        }

        // Patisanat image upload validation
        if (this.isPatisanat && !this.validatePatisanatImage()) {
          return;
        }

        this.handleErrorMessage();
        this.syncAutoshipSelector();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden",
        );

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];
        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id),
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        } else {
          // Request cart-icon-bubble section to update cart count when there's no cart drawer
          formData.append("sections", "cart-icon-bubble");
          formData.append("sections_url", window.location.pathname);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            }

            this.sendShopifyAddToCartEventAfterSuccess(response);

            if (!this.cart) {
              // Update cart icon bubble if section data is available
              if (response.sections && response.sections["cart-icon-bubble"]) {
                this.updateCartIconBubble(
                  response.sections["cart-icon-bubble"],
                );
              }
              // Publish cart update event for other components
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
              this.subscribeToInterestTagsAfterAddToCart();
              // Show custom confirmation dialog
              this.showCartConfirmationDialog();
              return;
            }

            this.subscribeToInterestTagsAfterAddToCart();

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true },
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner").classList.add(
              "hidden",
            );
          });
      }

      async handleNotifyMe() {
        const customerId = this.dataset.customerId;
        const loginUrl = this.dataset.loginUrl;
        const productId = this.dataset.productId;
        const variantId = this.variantIdInput.value;

        if (!customerId) {
          window.location.href = loginUrl;
          return;
        }

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        const originalText = this.submitButtonText.textContent;
        this.submitButtonText.textContent = "Yükleniyor...";
        this.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden",
        );

        try {
          const response = await window.subscribeToInventoryNotification(
            customerId,
            productId,
            variantId,
          );

          if (response.ok) {
            this.submitButton.classList.add("success");
            this.submitButtonText.textContent = "Kaydedildi!";

            setTimeout(() => {
              this.submitButton.classList.remove("success");
              this.submitButtonText.textContent = "Bildirim Aktif";
              this.submitButton.classList.add("subscribed");
            }, 2000);
          } else {
            throw new Error("Failed to subscribe");
          }
        } catch (error) {
          console.error("Notify when available error:", error);
          this.submitButton.classList.add("error");
          this.submitButtonText.textContent = "Hata oluştu";

          setTimeout(() => {
            this.submitButton.removeAttribute("aria-disabled");
            this.submitButton.classList.remove("error");
            this.submitButtonText.textContent = originalText;
          }, 2000);
        } finally {
          this.submitButton.classList.remove("loading");
          this.querySelector(".loading-overlay__spinner").classList.add(
            "hidden",
          );
        }
      }

      sendShopifyAddToCartEventAfterSuccess(cartAddResponse) {
        const customerId = (this.dataset.customerId || "").trim();
        if (
          !customerId ||
          typeof window.sendShopifyAddToCartEvent !== "function"
        ) {
          return;
        }

        window
          .sendShopifyAddToCartEvent(customerId, cartAddResponse)
          .catch((error) => {
            console.error("Shopify add-to-cart event error:", error);
          });
      }

      async subscribeToInterestTagsAfterAddToCart() {
        const customerId = this.dataset.customerId;
        if (!customerId || typeof window.subscribeCustomerTags !== "function") {
          return;
        }

        try {
          const productData = await this.getProductDataForInterestTags();
          const tags = this.buildInterestTags(productData);
          if (!tags.length) return;

          await window.subscribeCustomerTags(customerId, tags);
        } catch (error) {
          console.error("Interest tag subscription error:", error);
        }
      }

      buildInterestTags(productData = {}) {
        const tags = [];
        const vendorName = (productData.vendor || "").trim();
        if (vendorName) {
          tags.push(`InterestShop_Vendor_${vendorName}_Shop`);
        }

        const normalizedTags = (productData.tags || []).map((tag) =>
          String(tag || "")
            .trim()
            .toLowerCase(),
        );
        const matchedCategory = INTEREST_CATEGORY_TAGS.find((allowedTag) =>
          normalizedTags.includes(allowedTag),
        );
        if (matchedCategory) {
          tags.push(`InterestShop_Category_${matchedCategory}_Shop`);
        }

        return tags;
      }

      async getProductDataForInterestTags() {
        const dataVendor = (this.dataset.productVendor || "").trim();
        const dataTags = this.parseProductTagsFromDataset(
          this.dataset.productTags,
        );

        if (dataVendor || dataTags.length) {
          return {
            vendor: dataVendor,
            tags: dataTags,
          };
        }

        const productUrl = this.getProductUrlForInterestTags();
        if (!productUrl) return { vendor: "", tags: [] };

        const productPath = new URL(productUrl, window.location.origin)
          .pathname;
        const productJsonUrl = productPath.endsWith(".js")
          ? productPath
          : `${productPath}.js`;

        const response = await fetch(productJsonUrl);
        if (!response.ok) {
          throw new Error(`Failed to fetch product JSON: ${response.status}`);
        }

        const productJson = await response.json();
        return {
          vendor: productJson?.vendor || "",
          tags: Array.isArray(productJson?.tags) ? productJson.tags : [],
        };
      }

      parseProductTagsFromDataset(tagsString) {
        if (!tagsString) return [];

        try {
          const parsed = JSON.parse(tagsString);
          return Array.isArray(parsed) ? parsed : [];
        } catch (error) {
          return tagsString
            .split(",")
            .map((tag) => tag.trim())
            .filter(Boolean);
        }
      }

      getProductUrlForInterestTags() {
        if (this.dataset.productUrl) {
          return this.dataset.productUrl;
        }

        const productInfoUrl = this.closest("product-info")?.dataset?.url;
        if (productInfoUrl) {
          return productInfoUrl;
        }

        const productAnchor = this.closest(
          ".card, .product, .card-wrapper",
        )?.querySelector('a[href*="/products/"]');
        if (productAnchor) {
          return productAnchor.getAttribute("href");
        }

        return "";
      }

      initializeAutoshipSelector() {
        this.autoshipSelector = this.querySelector("[data-autoship-selector]");
        if (this.autoshipSelector) {
          this.setupAutoshipSelector();
        }
      }

      setupAutoshipSelector() {
        this.autoshipOptions = Array.from(
          this.autoshipSelector.querySelectorAll("[data-autoship-option]"),
        );
        this.autoshipFrequencyWrap = this.autoshipSelector.querySelector(
          "[data-autoship-frequency-wrap]",
        );
        this.autoshipFrequencyInput = this.autoshipSelector.querySelector(
          "[data-autoship-frequency]",
        );

        if (!this.autoshipOptions.length || !this.autoshipFrequencyInput) return;

        this.selectAutoshipOptionForCurrentProduct();

        if (this.autoshipSelectorInitialized) {
          this.syncAutoshipSelector();
          return;
        }

        this.autoshipOptions.forEach((option) => {
          option.addEventListener("change", () => {
            this.syncAutoshipSelector();
            this.switchAutoshipProduct(option);
          });
        });

        this.autoshipSelectorInitialized = true;
        this.syncAutoshipSelector();
      }

      selectAutoshipOptionForCurrentProduct() {
        const matchingOption = this.autoshipOptions.find((option) => {
          const productUrl = option.dataset.autoshipProductUrl;
          if (!productUrl) return false;

          return (
            new URL(productUrl, window.location.origin).pathname ===
            window.location.pathname
          );
        });

        if (matchingOption) {
          matchingOption.checked = true;
        }
      }

      syncAutoshipSelector() {
        if (!this.autoshipSelector || !this.autoshipOptions?.length) return;

        const selectedOption = this.autoshipOptions.find(
          (option) => option.checked,
        );
        const selectedType = selectedOption?.dataset.autoshipOptionType;
        const isSubscription = selectedType === "subscription";

        this.autoshipOptions.forEach((option) => {
          const card = option.closest("[data-autoship-card]");
          if (card) {
            card.classList.toggle("is-selected", option.checked);
          }
        });

        if (this.autoshipFrequencyWrap) {
          this.autoshipFrequencyWrap.hidden = !isSubscription;
        }

        if (this.autoshipFrequencyInput) {
          this.autoshipFrequencyInput.disabled = !isSubscription;
          if (isSubscription && !this.autoshipFrequencyInput.value) {
            this.autoshipFrequencyInput.selectedIndex = 0;
          }
        }
      }

      switchAutoshipProduct(option) {
        if (!option.checked) return;

        const productUrl = option.dataset.autoshipProductUrl;
        if (!productUrl) return;

        const targetUrl = new URL(productUrl, window.location.origin);
        if (targetUrl.pathname === window.location.pathname) return;

        const productInfo = this.closest("product-info");
        if (
          productInfo?.renderProductInfo &&
          productInfo?.buildRequestUrlWithParams &&
          productInfo?.handleSwapProduct
        ) {
          const shouldFetchFullPage =
            productInfo.dataset.updateUrl === "true" &&
            productInfo.dataset.url !== targetUrl.pathname;

          productInfo.resetProductFormState?.();
          productInfo.postProcessHtmlCallbacks?.push((newNode) => {
            newNode.querySelectorAll("product-form").forEach((productForm) => {
              productForm.initializeAutoshipSelector?.();
            });
          });
          productInfo.renderProductInfo({
            requestUrl: productInfo.buildRequestUrlWithParams(
              targetUrl.pathname,
              [],
              shouldFetchFullPage,
            ),
            targetId: option.id,
            callback: productInfo.handleSwapProduct(
              targetUrl.pathname,
              shouldFetchFullPage,
            ),
          });
          return;
        }

        window.location.href = targetUrl.href;
      }

      setupPatisanatImageUpload() {
        const uploadContainer = this.querySelector(".patisanat-image-upload");
        if (!uploadContainer) return;

        const fileInput = uploadContainer.querySelector(
          ".patisanat-image-upload__input",
        );
        const label = uploadContainer.querySelector(
          ".patisanat-image-upload__label",
        );
        const preview = uploadContainer.querySelector(
          ".patisanat-image-upload__preview",
        );
        const previewImg = uploadContainer.querySelector(
          ".patisanat-image-upload__preview-img",
        );
        const removeBtn = uploadContainer.querySelector(
          ".patisanat-image-upload__remove",
        );
        const errorEl = uploadContainer.querySelector(
          ".patisanat-image-upload__error",
        );

        if (!fileInput) return;

        // File input change handler
        fileInput.addEventListener("change", () => {
          if (errorEl) errorEl.hidden = true;
          const file = fileInput.files[0];
          if (file) {
            const reader = new FileReader();
            reader.onload = (e) => {
              if (previewImg) previewImg.src = e.target.result;
              if (preview) preview.hidden = false;
              if (label) label.hidden = true;
            };
            reader.readAsDataURL(file);
          }
        });

        // Remove button handler
        if (removeBtn) {
          removeBtn.addEventListener("click", () => {
            fileInput.value = "";
            if (preview) preview.hidden = true;
            if (previewImg) previewImg.src = "";
            if (label) label.hidden = false;
            if (errorEl) errorEl.hidden = true;
          });
        }

        // Drag and drop on label
        if (label) {
          ["dragenter", "dragover"].forEach((eventName) => {
            label.addEventListener(eventName, (e) => {
              e.preventDefault();
              e.stopPropagation();
              label.classList.add("patisanat-image-upload__label--dragover");
            });
          });
          ["dragleave", "drop"].forEach((eventName) => {
            label.addEventListener(eventName, (e) => {
              e.preventDefault();
              e.stopPropagation();
              label.classList.remove("patisanat-image-upload__label--dragover");
            });
          });
          label.addEventListener("drop", (e) => {
            const dt = e.dataTransfer;
            if (dt.files && dt.files.length > 0) {
              fileInput.files = dt.files;
              fileInput.dispatchEvent(new Event("change"));
            }
          });
        }
      }

      validatePatisanatImage() {
        const uploadContainer = this.querySelector(".patisanat-image-upload");
        if (!uploadContainer) return true;

        const fileInput = uploadContainer.querySelector(
          ".patisanat-image-upload__input",
        );
        const errorEl = uploadContainer.querySelector(
          ".patisanat-image-upload__error",
        );

        if (!fileInput || !fileInput.files || fileInput.files.length === 0) {
          if (errorEl) {
            errorEl.textContent =
              "Lütfen devam etmeden önce bir fotoğraf yükleyin.";
            errorEl.hidden = false;
          }
          uploadContainer.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
          return false;
        }

        const file = fileInput.files[0];
        const validTypes = ["image/jpeg", "image/png", "image/webp"];
        if (!validTypes.includes(file.type)) {
          if (errorEl) {
            errorEl.textContent =
              "Lütfen geçerli bir görsel formatı yükleyin (JPG, PNG veya WebP).";
            errorEl.hidden = false;
          }
          return false;
        }

        const maxSize = 5 * 1024 * 1024; // 5MB
        if (file.size > maxSize) {
          if (errorEl) {
            errorEl.textContent = "Dosya boyutu 5MB'den küçük olmalıdır.";
            errorEl.hidden = false;
          }
          return false;
        }

        if (errorEl) errorEl.hidden = true;
        return true;
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message",
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute("disabled", "disabled");
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute("disabled");
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      updateCartIconBubble(html) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const sectionElement = doc.querySelector(".shopify-section");

        if (sectionElement) {
          const newCartIconBubble =
            sectionElement.querySelector("#cart-icon-bubble");
          const newParent = sectionElement.querySelector(".wbhcart");

          if (newCartIconBubble || newParent) {
            // Update all cart icon bubble elements (there may be multiple with same ID)
            const allCartIcons = document.querySelectorAll("#cart-icon-bubble");

            allCartIcons.forEach((currentCartIcon) => {
              const parent = currentCartIcon.parentElement;
              if (parent && parent.classList.contains("wbhcart") && newParent) {
                // Replace the entire parent container
                parent.innerHTML = newParent.innerHTML;
              } else if (newCartIconBubble) {
                // Just update the cart icon bubble element
                currentCartIcon.innerHTML = newCartIconBubble.innerHTML;
              }
            });
          }
        }
      }

      showCartConfirmationDialog() {
        const isMobile = window.matchMedia("(max-width: 749px)").matches;

        // Create overlay
        const overlay = document.createElement("div");
        overlay.style.cssText =
          "position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0, 0, 0, 0.5); z-index: 9999; display: flex; align-items: center; justify-content: center;";

        // Create dialog
        const dialog = document.createElement("div");
        dialog.style.cssText = isMobile
          ? "background: white; padding: 2rem 1.5rem; border-radius: 12px; max-width: 520px; width: 95%; box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15); text-align: center;"
          : "background: white; padding: 2.5rem; border-radius: 12px; max-width: 520px; width: 95%; box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15); text-align: center;";

        // Create message
        const message = document.createElement("p");
        message.textContent = window.cartStrings.addToCartSuccess;
        message.style.cssText = isMobile
          ? "margin-bottom: 1.5rem; font-size: 1.5rem; line-height: 1.5; color: #222;"
          : "margin-bottom: 1.75rem; font-size: 1.75rem; line-height: 1.5; color: #222;";
        dialog.appendChild(message);

        // Create buttons container
        const buttonsContainer = document.createElement("div");
        buttonsContainer.style.cssText = isMobile
          ? "display: flex; flex-direction: column; gap: 0.75rem; width: 100%;"
          : "display: flex; gap: 1rem; justify-content: center;";

        const buttonBaseStyles = isMobile
          ? "padding: 0.9rem 1rem; border-radius: 6px; cursor: pointer; font-size: 1.4rem; white-space: nowrap; width: 100%; box-sizing: border-box;"
          : "padding: 0.9rem 1.75rem; border-radius: 6px; cursor: pointer; font-size: 1.5rem; white-space: nowrap; flex: 1;";

        // Continue Shopping button
        const continueBtn = document.createElement("button");
        continueBtn.textContent = window.cartStrings.continueShopping;
        continueBtn.style.cssText = `${buttonBaseStyles} background: #f5f5f5; border: 1px solid #ddd; color: #333;`;
        continueBtn.addEventListener("click", () => {
          document.body.removeChild(overlay);
        });
        continueBtn.addEventListener("mouseenter", () => {
          continueBtn.style.background = "#e5e5e5";
        });
        continueBtn.addEventListener("mouseleave", () => {
          continueBtn.style.background = "#f5f5f5";
        });

        // Go to Cart button
        const cartBtn = document.createElement("button");
        cartBtn.textContent = window.cartStrings.goToCart;
        cartBtn.style.cssText = `${buttonBaseStyles} border: none;`;
        // Use theme color scheme variables (always present)
        const rootStyles = getComputedStyle(document.documentElement);
        const primaryBg = `rgb(${rootStyles
          .getPropertyValue("--color-button")
          .trim()})`;
        const hoverBg = `rgb(${rootStyles
          .getPropertyValue("--color-bg-button-hover")
          .trim()})`;
        const textColor = `rgb(${rootStyles
          .getPropertyValue("--color-button-text")
          .trim()})`;

        cartBtn.style.background = primaryBg;
        cartBtn.style.color = textColor;

        cartBtn.addEventListener("click", () => {
          document.body.removeChild(overlay);
          window.location = window.routes.cart_url;
        });
        cartBtn.addEventListener("mouseenter", () => {
          cartBtn.style.background = hoverBg;
        });
        cartBtn.addEventListener("mouseleave", () => {
          cartBtn.style.background = primaryBg;
        });

        buttonsContainer.appendChild(continueBtn);
        buttonsContainer.appendChild(cartBtn);
        dialog.appendChild(buttonsContainer);

        overlay.appendChild(dialog);

        // Close on overlay click
        overlay.addEventListener("click", (e) => {
          if (e.target === overlay) {
            document.body.removeChild(overlay);
          }
        });

        document.body.appendChild(overlay);

        // Focus on continue shopping button by default
        continueBtn.focus();
      }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    },
  );
}
